import { render } from "./SubProjectListWidget.vue?vue&type=template&id=ba88de12&ts=true"
import script from "./SubProjectListWidget.ts?vue&type=script&lang=ts&external"
export * from "./SubProjectListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__